<template>
  <div class="page-add">
    <div class="add-title">编辑试卷</div>
    <el-form
      size="small"
      class="form"
      label-position="right"
      label-width="100px"
      :model="paperForm"
      ref="paperForm"
    >
      <el-row>
        <el-col>
          <el-form-item label="试卷名称：" prop="paperName" required>
            <el-input
              v-model="paperForm.paperName"
              placeholder="请输入试卷名称"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="试卷说明：" prop="paperDesc" required>
            <el-input
              type="textarea"
              v-model="paperForm.paperDesc"
              placeholder="请输入试卷说明"
              maxlength="200"
              autosize
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-select" label="试卷类型：" prop="paperType">
            <el-select
              v-model="paperForm.paperType"
              placeholder="请选择试卷类型"
              style="width:100%"
              @change="onPaperTypeChange"
            >
              <el-option
                v-for="item in paperTypeData"
                :key="parseInt(item.paramKey)"
                :label="item.paramValue"
                :value="parseInt(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="分数配置：" required>
            <paper-score
              ref="paperScore"
              :questionTypeData="questionTypeData"
              :questionList="questionList"
              :paperType="String(paperForm.paperType)"
            ></paper-score>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col>
          <el-radio-group
            v-model="examQuestionType"
            size="small"
            class="radio-menu"
          >
            <el-radio-button
              class="radio"
              v-for="item in questionTypeData"
              :key="item.paramKey"
              :label="item.paramKey"
              >{{ item.paramValue }}</el-radio-button
            >
          </el-radio-group>
          <el-form
            inline
            size="small"
            style="float: right"
            v-if="paperForm.paperType === 0"
          >
            <el-form-item>
              <el-checkbox
                v-model="dragaable"
                :disabled="dragDisabled"
                class="drag-box"
                style="padding-right:10px"
                >拖拽排序</el-checkbox
              >
            </el-form-item>
            <el-form-item>
              <butn
                title="批量移除"
                @click="deleteQuestions"
                style="margin-right:10px"
                :disabled="!batchEnable"
              ></butn>
            </el-form-item>
            <el-form-item>
              <butn
                btntype="primary"
                title="试题管理"
                @click="manageQuestions"
              ></butn>
            </el-form-item>
          </el-form>
          <butn
            v-else-if="paperForm.paperType === 1"
            class="import-question"
            btntype="primary"
            title="导入题库"
            @click="importQuestion"
          ></butn>
          <template v-else></template>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="试题列表："
            ><exam-question-list
              v-if="paperForm.paperType === 0"
              ref="questionList"
              :examQuestionType="examQuestionType"
              :questionList="questionList"
              :draggable="dragaable"
              @sort="sort"
              :isFromDetail="false"
            ></exam-question-list>
            <exam-question-list-auto
              v-else
              :examQuestionType="examQuestionType"
              :questionList="questionList"
            ></exam-question-list-auto
          ></el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <question-select @selectQuestions="selectQuestions"></question-select>
    <div class="form-handle">
      <el-button size="small" @click="resetForm">重置</el-button>
      <el-button size="small" @click="goBack">返回</el-button>
      <el-button size="small" type="primary" @click="submit">提交</el-button>
    </div>
    <question-import
      :defaultKeys="themeList"
      @questionList="handleQuestions"
    ></question-import>
  </div>
</template>

<script>
import PaperScore from "../add/paperScore";
import ExamQuestionList from "../add/examQuestionList";
import ExamQuestionListAuto from "../add/examQuestionListAuto";
import butn from "@/components/button";
import QuestionSelect from "../add/questionSelect";
import QuestionImport from "../add/questionImport";
import { getSysParamByTypes } from "@/api/sysParam";
import { Confirm } from "@/components/Confirm";
import vue from "@/main";
import { editExamPaper, getExamPaperInfo } from "@/api/examPaper";
import { setItem } from "@/utils/storage.js";
export default {
  // 给子组件提供试题分类和试题类型(用function的方式提供响应式数据)
  provide() {
    return {
      getQuestionCategoryData: () => this.questionCategoryData,
      getQuestionTypeData: () => this.questionTypeData,
      getQuestionType: () => this.examQuestionType
    };
  },
  components: {
    PaperScore,
    ExamQuestionList,
    ExamQuestionListAuto,
    QuestionSelect,
    QuestionImport,
    butn
  },
  data() {
    return {
      questionTypeData: [],
      questionCategoryData: [],
      paperTypeData: [],
      examQuestionType: "0",
      paperForm: {
        paperName: "",
        paperDesc: "",
        paperType: ""
      },
      dragaable: false,
      questionList: [],
      themeList: []
    };
  },
  created() {
    this.getExamInfo();
    vue.$on("deleteExamQuestion", async question => {
      const text = "确认移除该试题吗？";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        });
        this.questionList.splice(this.questionList.indexOf(question), 1);
      } catch (error) {
        if (error === "cancel") return;
      }
    });
    this.getSysParamByTypes(["EXAM_QUESTION_TYPE", "EXAM_QUESTION_CATEGORY", "PAPER_TYPE"]);
  },
  computed: {
    batchEnable() {
      return (
        this.questionList.length > 0 &&
        this.$refs["questionList"] &&
        this.$refs["questionList"].checkArray.length > 0
      );
    },
    dragDisabled() {
      if (this.questionList.length < 2) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dragaable = false;
        return true;
      }
      return false;
    }
  },
  methods: {
    goBack() {
      this.$router.push('/examPaper');
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.questionTypeData = res.data["EXAM_QUESTION_TYPE"].sort(function(a, b) {
          return parseInt(a.paramKey) - parseInt(b.paramKey);
        });
        this.questionCategoryData = res.data["EXAM_QUESTION_CATEGORY"] || [];
        this.paperTypeData = res.data["PAPER_TYPE"] || [];
      });
    },
    getExamInfo() {
      getExamPaperInfo(this.$route.query.id).then(res => {
        if (!res || res.code != 0) return;
        this.paperForm.paperName = res.data.paperName;
        this.paperForm.paperDesc = res.data.paperDesc;
        this.paperForm.paperType = res.data.paperType;
        this.themeList = res.data.themeList;
        this.$refs["paperScore"].questionScore.splice(
          0,
          3,
          res.data.singleQstScore,
          res.data.multipleQstScore,
          res.data.judgeQstScore
        );
        if (this.paperForm.paperType === 1) {
          this.$refs["paperScore"].questionNum.splice(
            0,
            3,
            res.data.singleQstCount,
            res.data.multipleQstCount,
            res.data.judgeQstCount
          );
          this.$refs["paperScore"].totalScore.splice(
            0,
            3,
            res.data.singleQstCount * res.data.singleQstScore,
            res.data.multipleQstCount * res.data.multipleQstScore,
            res.data.judgeQstCount * res.data.judgeQstScore
          );
        }

        this.$nextTick(() => {
          this.questionList = res.data.examQuestionList;
          // this.$refs["questionList"].examQuestionType = "0";
        });
      });
    },
    // 试题管理
    manageQuestions() {
      vue.$emit("openQuestionList", this.questionList);
    },
    // 选择了试题
    selectQuestions(list) {
      this.questionList = list;
    },
    // 试题排序
    sort(arr, type) {
      // 筛选出不是当前类型的
      let newArr = this.questionList.filter(ele => {
        return ele.examQuestionType != type;
      });
      // 将筛选出来的和排序后的数组合并
      this.questionList = newArr.concat(arr);
    },
    // 批量删除试题
    async deleteQuestions() {
      const text = "确认批量移除选中的试题吗？";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        });
        this.$refs["questionList"].checkArray.forEach(ele => {
          this.questionList.splice(this.questionList.indexOf(ele), 1);
        });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    importQuestion() {
      vue.$emit("importQuestion");
    },
    handleQuestions(val) {
      this.questionList = val[0];
      this.themeList = val[1];
    },
    onPaperTypeChange() {
      this.$refs["paperScore"].reset();
      this.examQuestionType = "0";
      this.questionList = [];
    },
    // 重置数据
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        this.$refs["paperForm"].resetFields();
        this.$refs["paperScore"].reset();
        this.examQuestionType = "0";
        this.questionList = [];
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    submit() {
      let singleQstScore = this.$refs["paperScore"].questionScore[0] || 0.0;
      let multipleQstScore = this.$refs["paperScore"].questionScore[1] || 0.0;
      let judgeQstScore = this.$refs["paperScore"].questionScore[2] || 0.0;
      let singleQstNum = this.$refs["paperScore"].questionNum[0];
      let multipleQstNum = this.$refs["paperScore"].questionNum[1];
      let judgeQstNum = this.$refs["paperScore"].questionNum[2];
      // 校验数据
      if (!this.paperForm.paperName) {
        this.$message({
          message: "请输入试卷名称",
          type: "warning"
        });
        return;
      } else if (!this.paperForm.paperDesc) {
        this.$message({
          message: "请输入试卷说明",
          type: "warning"
        });
        return;
      } else if (this.questionList.length === 0) {
        this.$message({
          message: "请选择试题",
          type: "warning"
        });
        return;
      } else {
        if (singleQstNum > 0 && singleQstScore == 0) {
          this.$message({
            message: "请输入单选题分值",
            type: "warning"
          });
          return;
        }
        if (multipleQstNum > 0 && multipleQstScore == 0) {
          this.$message({
            message: "请输入多选题分值",
            type: "warning"
          });
          return;
        }
        if (judgeQstNum > 0 && judgeQstScore == 0) {
          this.$message({
            message: "请输入判断题分值",
            type: "warning"
          });
          return;
        }
        if (this.paperForm.paperType === 1) {
          let singles = [];
          let multiples = [];
          let judges = [];
          this.questionList.forEach(ele => {
            if (ele.examQuestionType === 0) {
              singles.push(ele);
            } else if (ele.examQuestionType === 1) {
              multiples.push(ele);
            } else if (ele.examQuestionType === 2) {
              judges.push(ele);
            }
          });
          if (singleQstNum > singles.length) {
            this.$message({
              message: "输入单选题数量超过题库单选题数量,请重新输入",
              type: "warning"
            });
            return;
          }
          if (multipleQstNum > multiples.length) {
            this.$message({
              message: "输入多选题数量超过题库多选题数量,请重新输入",
              type: "warning"
            });
            return;
          }
          if (judgeQstNum > judges.length) {
            this.$message({
              message: "输入判断题数量超过题库判断题数量,请重新输入",
              type: "warning"
            });
            return;
          }
        }
      }
      editExamPaper({
        paperName: this.paperForm.paperName,
        paperDesc: this.paperForm.paperDesc,
        totalNum: parseInt(this.$refs["paperScore"].examTotalTest),
        totalScore: this.$refs["paperScore"].examTotalScore,
        examQuestionList: this.questionList.map(ele => ele.uuid),
        paperType: this.paperForm.paperType,
        singleQstScore,
        multipleQstScore,
        judgeQstScore,
        uuid: this.$route.query.id,
        singleQstCount: singleQstNum,
        multipleQstCount: multipleQstNum,
        judgeQstCount: judgeQstNum,
        themeList: this.themeList
      }).then(res => {
        if (!res || res.code != 0) return;
        this.$message({
          message: "编辑成功",
          type: "success"
        });
        setItem(this.REFRESH_FLAG, true);
        setTimeout(() => {
          this.goBack();
        }, 500);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-menu {
  margin-top: 10px;
  margin-left: 100px;
}
.dash-line {
  height: 0;
  border-bottom: 1px dashed #e8e8e8;
  margin: 10px 0;
}
.form-handle {
  text-align: center;
  margin-top: 20px;
}
.import-question {
  float: right;
  margin-top: 12px;
}
</style>
